
import type { RouteRecordRaw } from "vue-router";

const CompanyLayout = () => import("@/app/layouts/CompanyLayout.vue");
const SharedLayout = () => import("@/app/layouts/SharedLayout.vue");

const DashboardPage = () => import("@/modules/company/pages/DashboardPage.vue");
const MessagePage = () => import("@/modules/company/pages/MessagePage.vue");
const SettingsPage = () => import("@/shared/pages/SettingsPage.vue");
const PersonalInfoPage = () => import("@/shared/pages/PersonalInfoPage.vue");
const SavedAddressesPage = () => import("@/shared/pages/SavedAddressesPage.vue");
const SavedAddressEditPage = () => import("@/shared/pages/SavedAddressEditPage.vue");
const PaymentMethodsPage = () => import("@/shared/pages/PaymentMethodsPage.vue");
const HelpCenterPage = () => import("@/shared/pages/HelpCenterPage.vue");
const ContactSupportPage = () => import("@/shared/pages/ContactSupportPage.vue");
const TermsPrivacyPage = () => import("@/shared/pages/TermsPrivacyPage.vue");
const DeleteAccountPage = () => import("@/shared/pages/DeleteAccountPage.vue");


export const companyRoutes: RouteRecordRaw[] = [
  {
    path: "/company",
    component: CompanyLayout,
    meta: { requiresAuth: true, contextType: "company" },
    children: [
      {
        path: "dashboard",
        name: "company.dashboard",
        component: DashboardPage,
        meta: { title: "Dashboard" },
      },
    ],
  },
  {
    path: "/company",
    component: SharedLayout,
    meta: { requiresAuth: true, contextType: "company" },
    children: [
      { path: "", redirect: { name: "company.dashboard" } },
      {
        path: "settings",
        name: "company.settings",
        component: SettingsPage,
        meta: { title: "Settings" },
      },
      {
        path: "profile",
        name: "company.profile",
        component: PersonalInfoPage,
        meta: { title: "Personal Information" },
      },
      {
        path: "saved-addresses",
        name: "company.saved-addresses",
        component: SavedAddressesPage,
        meta: { title: "Saved Addresses" },
      },
      {
        path: "saved-addresses/:id",
        name: "company.saved-addresses.edit",
        component: SavedAddressEditPage,
        meta: { title: "Edit Address" },
      },
      {
        path: "payment-methods",
        name: "company.payment-methods",
        component: PaymentMethodsPage,
        meta: { title: "Payment Methods" },
      },
      {
        path: "help-center",
        name: "company.help-center",
        component: HelpCenterPage,
        meta: { title: "Help Center" },
      },
      {
        path: "contact-support",
        name: "company.contact-support",
        component: ContactSupportPage,
        meta: { title: "Contact Support" },
      },
      {
        path: "terms-privacy",
        name: "company.terms-privacy",
        component: TermsPrivacyPage,
        meta: { title: "Terms & Privacy" },
      },
      {
        path: "delete-account",
        name: "company.delete-account",
        component: DeleteAccountPage,
        meta: { title: "Delete Account" },
      },
      {
        path: "messages",
        name: "company.messages",
        component: MessagePage,
        meta: { title: "Messages" },
      },
    ],
  },
];
